import React from "react";

const SortIcon = () => {
  return (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="sort_24dp_UNDEFINED 1" clipPath="url(#clip0_8437_9883)">
        <path
          id="Vector"
          d="M1.75 14H6.75V12.3333H1.75V14ZM1.75 4V5.66667H16.75V4H1.75ZM1.75 9.83333H11.75V8.16667H1.75V9.83333Z"
          fill="black"
          fillOpacity="0.9"
        />
      </g>
      <defs>
        <clipPath id="clip0_8437_9883">
          <rect width="18" height="18" fill="white" transform="translate(0.25)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SortIcon;
